module.exports = __webpack_public_path__ + "img/escola_creative_learning_oficinageografia.1ded914f.jpeg";